export default __webpack_public_path__ + "media/megamenu-3.c903a445.svg";